import { defineComponent as _defineComponent } from 'vue'
import { BookV1 } from '@ilteducation/content-registry-types';
import { ref } from 'vue';
import FrontCoverUploader from '@/components/book/FrontCoverUploader.vue';
import EPUBUploader from '@/components/book/EPUBUploader.vue';
import BookAudioUploader from '@/components/book/BookAudioUploader.vue';
import VideoUploader from '@/components/book/VideoUploader.vue';
import useDownloadMedia from '@/comp/use-download-media';
import { ContainerFile, getMediaFilesList, PackageFile, parseEpubXml } from '@/foundations/helpers/epubFormat';

type Props = {
  id: string;
  item?: BookV1;
  title?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'BookFilesUpload',
  props: {
    id: null,
    item: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  item?: BookV1;
  title?: string;
}

const { downloadMediaUrl, downloadMediaFile } = useDownloadMedia();


const currentTab = ref<any>();
const allowedFileNames = ref<string[]>([]);

const getRequiredAudioFiles = async () => {
  const baseUrl = await downloadMediaUrl(props.id, { allContent: true });
  const containerData = await downloadMediaFile(`${baseUrl}/META-INF/container.xml`);
  const containerFile = await parseEpubXml<ContainerFile>(containerData);
  const packageData = await downloadMediaFile(
    `${baseUrl}/${containerFile.container!.rootfiles!.rootfile!['@_full-path']!}`,
  );
  const packageFile = await parseEpubXml<PackageFile>(packageData);
  // console.log(packageFile.package?.manifest?.item);
  const mediaFiles = getMediaFilesList(packageFile);
  console.log(mediaFiles);
  allowedFileNames.value = mediaFiles.map((name) => (name.indexOf('.') > -1 ? name.split('.')[0] : name));
};
getRequiredAudioFiles();

return { __sfc: true,downloadMediaUrl, downloadMediaFile, props, currentTab, allowedFileNames, getRequiredAudioFiles, FrontCoverUploader, EPUBUploader, BookAudioUploader, VideoUploader }
}

})